import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { Rating, RatingChangeEvent } from '@progress/kendo-react-inputs';
import { useContext, useState } from 'react';
import { PageContext } from './PageContext';

interface ConfirmDialogProps {
    type:string;
    title: string;
    message: string;
    confirmButtonText:string;
    cancelButtonText:string;
    onConfirm:() => void;
    onClose:()=>void;
}

interface AlertDialogProps {
    type:string;
    title: string;
    message: string;
    confirmButtonText:string;
    onClose:()=>void;
}


export function ConfirmDialog (props:ConfirmDialogProps){
    const pageContext=useContext(PageContext);
    var dlgClass:string ="" 
    switch (props.type){
            case "INFO":
                dlgClass="atol-dlg-info"
                break;
            case "WARN":
                dlgClass="atol-dlg-warn"
                break;
            case "DANGER":
                dlgClass="atol-dlg-error"
                break;
    }
    return(
        <Dialog title={props.title} onClose={props.onClose} width={"25%"} className={dlgClass}>
            <p><span dangerouslySetInnerHTML={{__html:props.message}}/></p>
            <DialogActionsBar>
                <Button onClick={props.onConfirm} themeColor={"secondary"}>{props.confirmButtonText}</Button>
                <Button onClick={props.onClose} themeColor={"primary"}>{props.cancelButtonText}</Button>
            </DialogActionsBar>
        </Dialog>
    )
}

export function AlertDialog (props:AlertDialogProps){
    const pageContext=useContext(PageContext);
    var dlgClass:string ="" 
    switch (props.type){
        case "INFO":
            dlgClass="atol-dlg-info"
            break;
        case "WARN":
            dlgClass="atol-dlg-warn"
            break;
        case "DANGER":
            dlgClass="atol-dlg-error"
            break;
    }
    return(

        <Dialog className='atol-dlg-error' title={props.title} onClose={props.onClose}>
            <p>{props.message}</p>
            <DialogActionsBar>
                <Button onClick={props.onClose}>{props.confirmButtonText}</Button>
            </DialogActionsBar>
        </Dialog>
    )
}

interface ApproveConfirmDialogProps {
    title: string;
    message: string;
    confirmButtonText:string;
    cancelButtonText:string;
    onConfirm:(rating:Rating)=>void;
    onClose:()=>void;
}

interface Rating{
    accuracy:number;
    creativity:number;
    timliness:number;
}

export function ApproveConfirmDialog (props:ApproveConfirmDialogProps){
    const [rating, setRating]=useState({
        accuracy:0,
        creativity:0,
        timliness:0
    });
    const pageContext=useContext(PageContext);
    
    const handleConfirm = () => {
        props.onConfirm(rating);
    }

    const handleARatingChange=(event: RatingChangeEvent)=>{
        setRating({ ...rating, accuracy: event.value });
    }
    const handleCRatingChange=(event: RatingChangeEvent)=>{
        setRating({ ...rating, creativity: event.value });
    }
    const handleTRatingChange=(event: RatingChangeEvent)=>{
        setRating({ ...rating, timliness: event.value });
    }

    return(
        <Dialog title={props.title} onClose={props.onClose}>
            <p>{props.message}</p>
            {pageContext?.glSettings.EnableAdRatings && 
            <>
            <p>Please rate your experience:</p>
            <p>Accuracy:<Rating onChange={handleARatingChange} max={parseInt(pageContext?.glSettings.RatingsMaxValue) ?? 5}></Rating></p>
            <p>Creativity:<Rating onChange={handleCRatingChange} max={parseInt(pageContext?.glSettings.RatingsMaxValue) ?? 5}></Rating></p>
            <p>Timliness:<Rating onChange={handleTRatingChange} max={parseInt(pageContext?.glSettings.RatingsMaxValue) ?? 5}></Rating></p>
            </>
            }
            <DialogActionsBar>
                <Button onClick={handleConfirm}>{props.confirmButtonText}</Button>
                <Button onClick={props.onClose}>{props.cancelButtonText}</Button>
            </DialogActionsBar>
        </Dialog>
    )
}            